var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 1.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1.5 L8.5,1.5 C8.5,0.672 7.828,0 7,0 C6.172,0 5.5,0.672 5.5,1.5 L4,1.5 L4,3.75 L10,3.75 L10,1.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4444444,2 L11.6666667,2 L11.6666667,4.33333333 L2.33333333,4.33333333 L2.33333333,2 L1.55555556,2 C0.696111111,2 0,2.69688889 0,3.55555556 L0,14.4444444 C0,15.3031111 0.696111111,16 1.55555556,16 L12.4444444,16 C13.3031111,16 14,15.3031111 14,14.4444444 L14,3.55555556 C14,2.69688889 13.3031111,2 12.4444444,2 Z M6.22222222,12.4338889 L3.339,9.54988889 L4.43877778,8.45088889 L6.22222222,10.2335556 L9.56122222,6.89455556 L10.661,7.99355556 L6.22222222,12.4338889 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.f2bfe136332ef3070a42aeb161551f03.svg";
export { ForwardRef as ReactComponent };